import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeOrganicFertilizers, getPracticeOrganicFertilizers } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_FERTILIZERS_ORGANIC } from "consts";

import { PracticeFertilizerOrganic, WithInjectedName } from "models";

export const useGetPracticeOrganicFertilizers = ({ enabled }: { enabled?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getAdminPracticeOrganicFertilizers : getPracticeOrganicFertilizers;

  return useQuery<Array<WithInjectedName<PracticeFertilizerOrganic>>>({
    queryKey: [GET_PRACTICES_FERTILIZERS_ORGANIC, enabled, isAdmin],
    queryFn: async () => {
      const fertilizers = await queryFn({ enabled });
      return fertilizers.map((f) => ({ ...f, name: t(`organicFertilizers.${f.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
